import { render } from "./Sapper.vue?vue&type=template&id=54cae99b"
import script from "./Sapper.vue?vue&type=script&lang=js"
export * from "./Sapper.vue?vue&type=script&lang=js"

import "./Sapper.vue?vue&type=style&index=0&id=54cae99b&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__